import React from 'react';
import styles from './styles/styles.module.scss';
import DatePicker from '../../shared/DatePicker';

import { ServerCommunicationUtil } from '../../../utils/server_communication_util';

class BannerManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBanners: [],
      displayMessage: null,
      createNewBannerMode: false
    };
  }

  componentDidMount() {
    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/admin/banners',
      {},
      this.handleCurrentBannerResults,
      () => {},
      () => {}
    );
  }

  toggleCreateMode = e => {
    this.setState({ createNewBannerMode: !this.state.createNewBannerMode });
  };

  handleBannerCreateSuccess = data => {
    // todo: make this a cleaner UX
    window.location.reload();
  };

  saveNewBannerClick = e => {
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/admin/banners',
      {
        couponCode: this.state.newCouponText,
        startDate: this.state.newStartDate,
        endDate: this.state.newEndDate,
        countries: [],
        message: this.state.newMessageText
      },
      this.handleBannerCreateSuccess,
      () => {},
      () => {}
    );
  };

  handleCurrentBannerResults = data => {
    this.setState({ currentBanners: data });
  };

  handleOnNewCodeInputChange = e => {
    e.preventDefault();
    this.setState({ newCouponText: e.currentTarget.value });
  };

  handleOnNewMessageChange = e => {
    e.preventDefault();
    this.setState({ newMessageText: e.currentTarget.value });
  };

  handleStartDateChange = newStartDate => {
    this.setState({ newStartDate });
  };

  handleEndDateChange = newEndDate => {
    this.setState({ newEndDate });
  };

  renderBannerDiv(banner) {
    const startDateParsed = new Date(banner.startDate);
    const endDateParsed = new Date(banner.endDate);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return (
      <div className={styles.couponCard}>
        <h4>
          Link:{' '}
          <a href={`/pro?k=${banner.code}`} target="_blank">
            Here
          </a>
        </h4>
        <h4>{`Type: ${banner.type}`}</h4>
        <h4>{`Message: ${banner.message}`}</h4>
        <h4>{`Start Date: ${startDateParsed.toLocaleDateString('en-US', options)}`}</h4>
        <h4>{`End Date: ${endDateParsed.toLocaleDateString('en-US', options)}`}</h4>
        <a href={`/edit-translations?table=banners&column_name=message&id=${banner.id}`}>Edit Translations</a>
      </div>
    );
  }

  renderCurrentBannerDisplay() {
    if (this.state.createNewBannerMode) {
      return null;
    }

    const bannerElements = this.state.currentBanners.map(b => this.renderBannerDiv(b));

    return <div className={styles.couponBoxContainer}>{bannerElements}</div>;
  }

  renderNewBannerForm() {
    if (this.state.createNewBannerMode) {
      return (
        <div>
          <button className={styles.searchButtons} onClick={this.toggleCreateMode}>
            Cancel
          </button>
          <button className={styles.searchButtons} onClick={this.saveNewBannerClick}>
            Save
          </button>
          <div>
            <div className={styles.inputEditContainer}>
              <input
                onChange={this.handleOnNewCodeInputChange}
                value={this.state.newCouponText}
                className={styles.searchBox}
                placeholder="Enter new coupon code"
              />
            </div>
            <div className={styles.inputEditContainer}>
              <input
                onChange={this.handleOnNewMessageChange}
                value={this.state.newMessage}
                className={styles.searchBox}
                placeholder="Enter message"
              />
            </div>
            <DatePicker date={this.state.newStartDate} onChange={this.handleStartDateChange} disableFuture={false} />
            <DatePicker date={this.state.newEndDate} onChange={this.handleEndDateChange} disableFuture={false} />
          </div>
        </div>
      );
    }
    return null;
  }

  renderButtonDiv() {
    if (this.state.createNewBannerMode) {
      return null;
    }
    return (
      <button className={styles.searchButtons} onClick={this.toggleCreateMode}>
        Create banner
      </button>
    );
  }

  renderTitleDiv() {
    let title = null;
    if (this.state.createNewBannerMode) {
      title = 'Creating a banner';
    } else {
      title = 'View all banners';
    }
    return <h2>{title}</h2>;
  }

  render() {
    return (
      <div className={styles.container}>
        {this.renderTitleDiv()}
        {this.renderButtonDiv()}
        {this.renderCurrentBannerDisplay()}
        {this.renderNewBannerForm()}
      </div>
    );
  }
}

export default BannerManager;
